import { SvgProps } from "@/utils/types";

export const Watermelon = ({
  primaryColor = "#F96E09",
  secondaryColor = "#06B992",
  outlineColor = "#0E5654",
  className,
}: SvgProps) => {
  return (
    <svg
      width="106"
      height="99"
      viewBox="0 0 106 99"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_5_936)">
        <path
          d="M94.0389 40.399C85.5389 69.6279 56.2181 87.7787 26.2395 82.3129C24.8799 82.0653 23.994 80.7191 24.3137 79.3632L36.7407 26.1777C37.0465 24.8766 38.3531 24.0609 39.6542 24.3667L91.8128 36.5569C93.5202 36.9579 94.5221 38.7124 94.0337 40.3905L94.0389 40.399Z"
          fill={secondaryColor}
        />
        <path
          d="M68.4675 76.5793C56.0979 83.9712 41.1189 87.0162 25.8999 84.24C24.7221 84.0235 23.6789 83.3305 23.0204 82.3261C22.3619 81.3216 22.1429 80.0779 22.4142 78.9139L34.8327 25.7336C35.0971 24.597 35.7951 23.6207 36.7892 23.0034C37.8004 22.3758 38.9618 22.1943 40.0983 22.4587L92.2569 34.649C93.5992 34.9652 94.733 35.7904 95.4289 36.9938C96.1231 38.175 96.2989 39.6193 95.9141 40.9443C91.4139 56.4364 81.3608 68.8745 68.4675 76.5793ZM38.8687 26.3273C38.7914 26.3735 38.6952 26.4659 38.6572 26.6167L26.2216 79.8073C26.1802 79.9719 26.2348 80.1023 26.2896 80.1744C26.3357 80.2517 26.4333 80.3565 26.5962 80.3756C55.7107 85.6821 83.9018 68.253 92.1534 39.8366C92.2707 39.4287 92.1392 39.1112 92.0469 38.9566C91.9597 38.8107 91.7561 38.548 91.3635 38.4564L39.2101 26.2747C39.0592 26.2367 38.9374 26.2862 38.8601 26.3324L38.8687 26.3273Z"
          fill={outlineColor}
        />
        <path
          d="M87.2834 38.5297C79.7777 64.1589 54.1291 80.0918 27.8346 75.4884C26.4664 75.2459 25.589 73.8946 25.9001 72.5437L36.7407 26.1777C37.0465 24.8766 38.3531 24.0609 39.6542 24.3667L85.2026 35.0086C86.7728 35.3749 87.7321 36.9802 87.2783 38.5211L87.2834 38.5297Z"
          fill={primaryColor}
        />
        <path
          d="M64.8477 70.5413C53.9802 77.0355 40.8472 79.7578 27.5036 77.4103C26.3309 77.2024 25.2791 76.5146 24.6206 75.5101C23.9621 74.5057 23.7294 73.2585 24.0093 72.0894L34.8327 25.7336C35.3822 23.3782 37.7429 21.9092 40.0984 22.4587L85.6467 33.1006C86.9204 33.3995 88.0405 34.2213 88.6954 35.3561C89.3639 36.4943 89.5211 37.81 89.1535 39.0664C85.1608 52.7175 76.2542 63.7016 64.8374 70.5241L64.8477 70.5413ZM38.8601 26.3324C38.7571 26.394 38.6712 26.5036 38.6401 26.627L27.8167 72.9828C27.7718 73.161 27.8402 73.2949 27.8812 73.3636C27.9274 73.4409 28.0198 73.5371 28.1741 73.5614C53.56 78.0088 78.1579 62.7154 85.4082 37.9844C85.4945 37.6999 85.3954 37.4562 85.3287 37.3446C85.2569 37.2244 85.0875 36.9995 84.7635 36.9252L39.2101 26.2747C39.0866 26.2436 38.9631 26.2708 38.8601 26.3324Z"
          fill={outlineColor}
        />
        <path
          d="M91.5719 37.9474C91.1513 38.1987 90.6384 38.2956 90.1224 38.1729L36.8495 25.7166C35.7952 25.4729 35.142 24.4187 35.3857 23.3644C35.6293 22.3102 36.6835 21.6569 37.7378 21.9006L91.0055 34.3483C92.0598 34.592 92.713 35.6462 92.4694 36.7005C92.3484 37.2388 92.0046 37.6772 91.5668 37.9388L91.5719 37.9474Z"
          fill={outlineColor}
        />
        <path
          d="M56.0673 38.4983C56.908 39.3006 56.9365 40.635 56.1427 41.4705C55.3488 42.306 54.0059 42.3396 53.1704 41.5458C52.3298 40.7434 49.4712 36.7201 50.2736 35.8795C51.076 35.0388 55.2318 37.7044 56.0725 38.5068L56.0673 38.4983Z"
          fill={outlineColor}
        />
        <path
          d="M46.2204 45.9204C46.5459 47.0305 45.9076 48.2042 44.7974 48.5298C43.6872 48.8554 42.5136 48.217 42.188 47.1068C41.8624 45.9967 41.403 41.0755 42.5132 40.75C43.6233 40.4244 45.8948 44.8102 46.2204 45.9204Z"
          fill={outlineColor}
        />
        <path
          d="M69.2362 45.5051C70.1593 46.2116 70.3216 47.5358 69.6151 48.459C68.9086 49.3821 67.5844 49.5444 66.6612 48.8379C65.7381 48.1314 62.4776 44.4298 63.1841 43.5067C63.8906 42.5835 68.3045 44.8037 69.2276 45.5102L69.2362 45.5051Z"
          fill={outlineColor}
        />
        <path
          d="M57.6489 56.6233C58.2011 57.6447 57.8215 58.92 56.8001 59.4721C55.7787 60.0243 54.5034 59.6447 53.9513 58.6233C53.3992 57.6019 51.9241 52.8916 52.9455 52.3395C53.9669 51.7874 57.0968 55.6019 57.6489 56.6233Z"
          fill={outlineColor}
        />
        <path
          d="M42.5542 62.0673C42.6413 63.2268 41.7752 64.2337 40.6157 64.3208C39.4562 64.4079 38.4493 63.5418 38.3622 62.3823C38.2751 61.2228 38.8394 56.319 39.9989 56.2318C41.1584 56.1447 42.4619 60.8993 42.5491 62.0588L42.5542 62.0673Z"
          fill={outlineColor}
        />
        <path
          d="M26.2217 79.8073L22.4126 78.8916L35.3908 23.373C35.6345 22.3187 36.6887 21.6655 37.743 21.9092C38.7972 22.1529 39.4505 23.207 39.2068 24.2613L26.2217 79.8073Z"
          fill={outlineColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_5_936">
          <rect
            width="85.43"
            height="63.24"
            fill="white"
            transform="translate(0 43.8231) rotate(-30.8619)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
